import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { gridColsMap } from "../../../../../Constants/SocialLinks";
import { IStepFields } from "../../../../../interface/MedicalRecord";
import { FieldRenderer } from "../../FieldRenderer/FieldRenderer";
import { t } from "i18next";
import { GeneralSelect } from "../../../../../components";
import { GeneralSelectProps } from "../../../../../components/Inputs/GeneralSelect";

interface IMedicalGeneralSelect extends Omit<GeneralSelectProps, "options"> {
  field: IStepFields;
  selectOptions: any;
  options?: any;
  isRequired?: boolean;
}

const MedicalGeneralSelect: React.FC<IMedicalGeneralSelect> = ({
  field,
  selectOptions,
  name,
  isRequired,
  ...props
}) => {
  const methods = useFormContext();
  const selectedOption = selectOptions?.find(
    (item: any) => `${methods.watch(name)}` == `${item?.value}`,
  );

  const convertToPascalCase = (str: string): string => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join("");
  };

  const optionHasChildren =
    selectedOption?.InverseParentStepFields &&
    selectedOption?.InverseParentStepFields?.length > 0;

  const itemsLength =
    (selectOptions?.[0]?.InverseParentStepFields?.length ?? 0) + 1;

  const gridColsClass =
    gridColsMap[itemsLength as keyof typeof gridColsMap] || "grid-cols-1";

  const currentValue = methods.getValues(convertToPascalCase(field?.NameEn));
  const [hasConverted, setHasConverted] = React.useState(false);

  useEffect(() => {
    if (!hasConverted && currentValue && typeof currentValue === "string") {
      const matchedOption = selectOptions?.find(
        (option: any) =>
          option.label === currentValue ||
          option.key === currentValue ||
          option.Name === currentValue,
      );

      if (
        matchedOption &&
        matchedOption.value &&
        matchedOption.value !== currentValue
      ) {

        methods.setValue(name, matchedOption.value);
        setHasConverted(true);
      } else {
        setHasConverted(true);
      }
    }
  }, [currentValue, name, selectOptions, methods, hasConverted]);
  return (
    <div className={`grid ${gridColsClass} items-center gap-1`}>
      <GeneralSelect
        name={name}
        placeholderCustomStyle={{
          color: "#3F4869 !important",
        }}
        customControlStyles={{
          background: "white !important",
          minHeight: "50px !important",
          border: "1px solid #566B8D !important",
        }}
        placeholder={field?.Name}
        isClearable
        {...props}
        options={selectOptions as any}
      />
      {isRequired && !methods.watch(name) && (
        <p className="text-error mt-1 text-sm">{t("required")}</p>
      )}
      {optionHasChildren && (
        <div className="flex gap-2">
          {selectedOption?.InverseParentStepFields?.map(
            (item: any, index: number) => {
              return (
                <FieldRenderer
                  key={index}
                  field={{
                    ...item,
                    Key: `${field?.ParentName}.${item.Key ?? item.Id}`,
                  }}
                />
              );
            },
          )}
        </div>
      )}
    </div>
  );
};

export default MedicalGeneralSelect;
